<template>
	<div class="menu-wrapper" :class="{ 'menu-wraper--isVisible': isVisible }">
		<!-- Logo -->
		<div class="logo" :style="logoStyle">
			<img
				v-if="logo"
				:src="require(`@/assets/img/${logo}`)"
				:style="logoImgStyle"
			/>
			<div v-else class="fw7 fs4">ABC COMPANY</div>
		</div>

		<!-- Menu -->
		<nav class="menu">
			<router-link
				v-for="(item, i) in features"
				:key="i"
				tag="li"
				:to="`/${$route.params.tenantId}/${item.slug}`"
				@click.native="hideMenu"
				class="menu-item"
				active-class="active"
			>
				<!-- icon -->
				<crm-icon
					v-if="item.icon"
					:name="item.icon"
					class="mr2"
					:color="'c4'"
				/>
				<!-- label -->
				{{ item.name }}
			</router-link>
		</nav>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import { can } from "@/permissions/index.js"
import possibleFeatures from "@/clientSettings/possibleFeatures.js"

export default {
	components: { CrmIcon },
	computed: {
		isVisible() {
			return this.$store.state.isMenuVisible
		},

		logo() {
			return this.$store.state.settings && this.$store.state.settings.logo
				? this.$store.state.settings.logo
				: null
		},

		features() {
			// TODO: move possible features into clientsSettings new file
			if (
				!this.$store.state.settings ||
				!this.$store.state.permissions ||
				!this.$store.state.settings.features
			)
				return []

			// Get features based on tenant settings
			const featuresBeforePermissions = this.$store.state.settings.features.map(
				id => possibleFeatures.find(feature => feature.id === id)
			)

			// Based on permissions, remove features that are not allowed for logged in user
			return featuresBeforePermissions
				.filter(feature => {
					if (feature.id === "clients") {
						if (can("readIndividuals") || can("readCompanies")) return true
						else return false
					} else if (
						// TODO: hardcoding some features
						// Permissions are not needed to display this feature
						feature.id === "dashboard" ||
						feature.id === "setup" ||
						feature.id === "commissions" ||
						feature.id === "users" ||
						feature.id === "leads" ||
						feature.id === "notifications" ||
						feature.id === "organizations" ||
						feature.id === "caseManagement" ||
						feature.id === "binders" ||
						feature.id === "transactions" ||
						feature.id === "objects" ||
						feature.id === "fileSystem" ||
						feature.id === "plans"
					)
						return true
					else {
						if (can(feature.permission)) return true
						else return false
					}
				})
				.map(feature => {
					return {
						...feature,
						name: this.$t(feature.i18nKey)
					}
				})
		},

		logoStyle() {
			if (this.$store.state?.settings?.theme?.logoBackgroundColor)
				return `background-color: ${this.$store.state.settings.theme.logoBackgroundColor}`
			else return ""
		},
		logoImgStyle() {
			if (this.$store.state?.settings?.theme?.logoWidth)
				return `width: ${this.$store.state.settings.theme.logoWidth}; height:auto`
			else return `width: 100%; height: auto`
		}
	},

	methods: {
		hideMenu() {
			this.$store.commit("SET_MENU", false)
		},
		setLocale(locale) {
			this.$store.dispatch("setLocale", locale)
		}
	}
}
</script>

<style scoped>
@import "../../../assets/css/tokens.css";

/* Hide scrollbars for Chrome */
.menu-wrapper::-webkit-scrollbar {
	display: none !important;
}

.menu-wrapper {
	display: none;
	position: fixed;
	top: 0px;
	left: 0;
	width: 100%;
	height: 100vh;
	background-color: var(--color1);
	-webkit-overflow-scrolling: touch;
	-ms-overflow-style: none; /* Hide scrollbars on ie11 */
	scrollbar-width: none; /* Hide scrollbars on firefox */
	overflow-y: scroll;
	z-index: 100;
}

.menu-wraper--isVisible {
	display: block !important;
}

.logo {
	width: 100%;
	height: 56px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: var(--spacing10);
	border-bottom: 1px solid var(--color5-alpha-10);
	background-color: var(--color1);
	color: var(--color5);
	padding-left: 5px;
	padding-right: 5px;
}

.icons {
	width: auto;
	height: 22px;
	display: flex;
	align-items: center;
	margin-right: var(--spacing3);
	color: var(--color5);
}

.menu {
	width: 100%;
	height: 100%;
	list-style: none;
	user-select: none;
	z-index: 100;
}

.menu::-webkit-scrollbar {
	display: none;
	height: 0;
	opacity: 0;
}

.menu-item {
	position: relative;
	display: inline-flex;
	justify-content: flex-start;
	align-items: center;
	padding: var(--spacing2);
	width: 100%;
	height: 40px;
	color: var(--color5-alpha-70);
	font-size: var(--fontSize3);
	font-weight: var(--fontWeight7);
	white-space: nowrap;
	text-transform: uppercase;
	cursor: pointer;
}

.menu-item:hover {
	color: var(--color5);
	transition: all 110ms ease-out;
}

.menu-item.active {
	color: var(--color5);
	background-color: var(--color2);
}

.menu-item::before {
	content: "";
	position: absolute;
	right: 1px;
	height: 95%;
	width: 0px;
	background-color: var(--color0);
	opacity: 0;
}

.active.menu-item::before {
	background-color: var(--color3);
	opacity: 1;
	transform: translateX(0);
	animation: underline 300ms ease-out;
}

@keyframes underline {
	0% {
		transform: translateY(-20%);
		opacity: 0;
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

@media (--md) {
	.menu-wrapper {
		width: 180px;
		display: block;
	}
}
</style>
